import { type JanusReaders, type Row, scalar } from './context.js';
import { phpIntval } from '../rolls/dice-roll.js';
import { is_numeric } from '../php-compat/values.js';

/** damage_type_roll.php's VARIABLE DICE branch followed by roll_dice_arr's intval().
 * Empty/missing X, or a boundary's damage_only mode, rolls zero dice. Other authored dice stay untouched. */
export function variableDice(dice: unknown, variable1: unknown): unknown {
  return scalar(dice) === '[x]' ? phpIntval(scalar(variable1)) : dice;
}

/** The sheet's charges/mana/targets picker sends an amount in slot 1, independently of a spell level. */
export function isVariableAmount(ctx: { read: Pick<JanusReaders, 'value'> }, ability: Row, variable1: unknown): boolean {
  return is_numeric(variable1) && Number.isFinite(Number(variable1))
    && ['dice', 'consumes_charges_qty', 'change_caster_mana', 'max_targets']
      .some(key => String(scalar(ctx.read.value(ability, key)) ?? '').includes('[x]'));
}
